const theme = {
  lightMode: {
    primaryOrange: "#FF6300",
    secondaryOrnage: "#FFEFE5",
    checkGreen: "#037E0B",
    checkGray: "#B6C4C8",
    orange50: "#FFDFCC",
    primaryPurple: "#5C0FD9",
    primaryGray: "lightgray",
    secondaryGray: "#666666",
    primaryWhite: "#FFFFFF",
    white50: "#f1f1f1",
    primaryBlack: "#000",
    lightPurple: "#DECFF6",
    successGreen: "#037E0B",
    errorRed: "#D31313",
    enablePurple: "#eee7fa",
    backgroundColor: "#FFFFFF",
    inputError: "#ff0041"
  },
  darkMode: {
    primary: '',
    secondary: '',
    background: '',
  },
  fontFamily: {
    primary: ["Roboto", 'sans-serif']
  }
};

export default theme;